import React from "react";
import pdf from '../Assets/pdf_ico.png';


export default () => {
  return (
    <img src={pdf} alt='Profile' className='img-fluid' style={{width:20}} />
  )
}
